import z from "zod";

export const getVehicleParamSchema = z.object({
	vehicleId: z.uuid(),
});

export const getVehicleQuerySchema = z.object({
	startDate: z.string(),
	endDate: z.string(),
});

export type GetVehicleParamSchema = z.infer<typeof getVehicleParamSchema>;
export type GetVehicleQuerySchema = z.infer<typeof getVehicleQuerySchema>;
